<template>
    <div class="loader"
         :class="inline ? 'inline' : ''">
        <i class="glyphicon glyphicon-refresh"></i>
    </div>
</template>

<style scoped
       lang="less">
    @keyframes spinning {
        0% {
            transform: rotateZ(0deg);
        }

        100% {
            transform: rotateZ(360deg);
        }
    }

    .loader {
        text-align: center;

        i {
            animation-duration: 1s;
            animation-name: spinning;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
    }

    .inline {
        display: inline-block;
    }
</style>

<script type="text/ecmascript-6">
    export default {
        props: {
            inline: {
                'default': false
            }
        }
    };
</script>



// WEBPACK FOOTER //
// Loader.vue?4aeafe94